export const POSITIVE_SLIDER_DEFAULT_VALUE = 60
export const NEGATIVE_SLIDER_DEFAULT_VALUE = 40
export const SINGLE_SLIDER_DEFAULT_VALUE = 0

export const MIN_SLIDER_VALUE = 0
export const MAX_SLIDER_VALUE = 100

export const NUM_OF_BARS_PER_PAGE = 5
